<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="usersMain">
          <v-card id="usersCard">
            <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t('nav.usersAdministration') }}</v-card-title>
            <v-data-table id="usersTable" :headers="headers" :items="items" :items-per-page="10" class="elevation-0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.username }}</td>
                  <td style="text-align: left">{{ props.item.firstName }}</td>
                  <td style="text-align: left">{{ props.item.lastName }}</td>
                  <td style="text-align: left">{{ props.item.email }}</td>
                  <td style="text-align: left">{{ props.item.company }}</td>
                  <td style="text-align: left">{{ props.item.roleName }}</td>
                  <td style="text-align: center">
                    <v-btn id="btnDel" color="primary" x-small fab outlined elevation="1" @click="deleteItemConfirm(props.item)">
                      <v-icon small color="primary">mdi-delete</v-icon>
                    </v-btn>&nbsp;
                    <v-btn id="btnEdit" color="primary" x-small fab outlined elevation="1" :disabled="props.item.isDeleted" @click="editItem(props.item)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.username"
                          :rules="[() => !!editedItem.username || requiredMessage]"
                          required
                          autocomplete="false"
                          :readonly="editedIndex != -1"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('user.username') }}
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field type="password" v-model="editedItem.password" autocomplete="false" :readonly="editedIndex != -1" v-if="editedIndex == -1">
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('user.password') }}
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.firstName" :rules="[() => !!editedItem.firstName || requiredMessage]" required>
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('user.firstname') }}
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.lastName" :rules="[() => !!editedItem.lastName || requiredMessage]" required>
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('user.lastname') }}
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <email-input v-model="editedItem.email" label="user.email" required></email-input>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.company" :rules="[() => !!editedItem.company || requiredMessage]" required>
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('user.company') }}
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <v-select
                          class="form-control"
                          :items="roles"
                          item-text="description"
                          item-value="id"
                          v-model="editedItem.roleId"
                          @change="onRoleChange"
                        >
                          <template v-slot:label>{{ $t('user.role') }}</template>
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="canAssignProjects">
                      <v-col>
                        <label>{{ $t('nav.projects') }}</label>
                        <v-list class="sc prj-vessels">
                          <v-list-item v-for="p in projectVesselMappings" :key="p.id">
                            <v-list-item-action>
                              <v-checkbox color="primary" :id="'pvm-' + p.id" :value="p.isAssigned" v-model="p.isAssigned"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                              <label :for="'pvm-' + p.id">{{ p.projectVesselName }}</label>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{ $t('common.cancel') }}</v-btn>
                  <v-btn color="primary" text @click="save" :disabled="!formIsValid">{{ $t('common.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn id="btnAddusers" color="primary" dark small left fab @click="createItem()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from "vuex";
  import EmailInput from "./common/EmailInput.vue";
  var userRole = require("../store/modules/user-role/user-roles");

  export default {
    components: { EmailInput },
    data() {
      return {
        dialog: false,
        requiredMessage: this.$t("common.required"),
        headers: [
          {
            text: this.$t("user.username"),
            align: "left",
            value: "username",
          },
          {
            text: this.$t("user.firstname"),
            align: "left",
            value: "firstname",
          },
          {
            text: this.$t("user.lastname"),
            align: "left",
            value: "lastname",
          },
          {
            text: this.$t("user.email"),
            align: "left",
            value: "email",
          },
          {
            text: this.$t("user.company"),
            align: "left",
            value: "company",
          },
          {
            text: this.$t("user.role"),
            align: "left",
            value: "roleId",
          },
          {
            text: this.$t("column.actions"),
            align: "center",
            value: "opactions",
            sortable: false,
            width: "20%",
          },
        ],

        projectVesselMappings: [],

        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
      };
    },
    computed: {
      ...mapGetters([
        "getProjectVesselMappings",
        "m_user/getUsers",
        "m_role/getRoles",
        "m_userInRoles/getUserInRoles",
        "m_user/getUserProjects",
      ]),
      formTitle() {
        return this.editedIndex === -1
          ? this.$t("common.new") + " " + this.$t("user.user")
          : this.$t("common.edit") + " " + this.$t("user.user");
      },

      items() {
        return this["m_user/getUsers"];
      },

      roles() {
        return this["m_role/getRoles"];
      },

      userInRoles() {
        return this["m_userInRoles/getUserInRoles"];
      },

      formIsValid() {
        return (
          this.editedItem.username &&
          this.editedItem.firstName &&
          this.editedItem.lastName &&
          this.editedItem.email
        );
      },

      canAssignProjects() {
        let roleName = this.editedItem.roleName;
        this.$log.debug("edited user role is", roleName);
        return roleName && userRole.REPORTING_ADMIN_ROLE != roleName;
      },
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.refreshUsers();
    },

    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },

    methods: {
      ...mapActions([
        "fetchProjectVesselMappings",

        "m_user/createUser",
        "m_user/fetchUsers",
        "m_user/deleteUser",
        "m_user/updateUser",
        "m_user/createUserProjectVesselMapping",
        "m_user/deleteUserProjectVesselMapping",

        "m_role/fetchRoles",
        "m_userInRole/fetchUserInRoles",
      ]),
      ...mapMutations(["mHideLongLoader"]),

      refreshUsers() {
        this.$log.debug("refreshing users & roles..");
        this["m_user/fetchUsers"]();
        this["m_role/fetchRoles"]();
        this.fetchProjectVesselMappings();
      },

      resetEntity(item) {
        this.editedIndex = item ? this.items.indexOf(item) : -1;
        this.editedItem = Object.assign({}, item || this.defaultItem);

        var pvMappingIds = [];
        (this.editedItem.userProjects || []).forEach((upv) =>
          pvMappingIds.push(upv.projectInVesselId)
        );
        this.editedItem.pvMappingIds = pvMappingIds;

        this.projectVesselMappings = Object.assign(
          [],
          this.getProjectVesselMappings
        );
        this.projectVesselMappings.forEach((pvm) => {
          pvm.isAssigned = pvMappingIds.indexOf(pvm.id) !== -1;
        });
      },

      editItem(item) {
        this.resetEntity(item);
        this.dialog = true;
      },

      createItem() {
        this.resetEntity();
        this.dialog = true;
      },

      deleteItemConfirm(item) {
        this.resetEntity(item);

        var msg = this.editedItem.isDeleted ? "warming.unlock" : "warming.lock";

        this.$confirm(this.$t(msg) + this.$t(" entry") + "?", {
          buttonTrueText: this.$t("common.ok"),
          buttonFalseText: this.$t("common.cancel"),
          color: "warning",
          icon: "warning",
          title: this.$t("common.warning"),
          width: 350,
          property: "$confirm",
        }).then(
          (res) =>
            res &&
            this["m_user/deleteUser"](this.editedItem).then(this.refreshUsers)
        );
      },

      close() {
        this.dialog = false;
      },

      save() {
        let promise = null;
        if (~this.editedIndex) {
          promise = this["m_user/updateUser"](this.editedItem);
        }

        if (!~this.editedIndex) {
          promise = this["m_user/createUser"](this.editedItem);
        }

        promise
          .then((user) => this.updateUserProjectVesselMapping(user))
          .then(this.refreshUsers);

        this.close();
      },

      updateUserProjectVesselMapping(user) {
        let userId = user.ID || this.editedItem.id;
        this.$log.debug(
          "Save/Update user",
          userId,
          "<-> (project, vessel) mapping"
        );
        var assignments = {
          toAdd: [],
          toRemove: [],
        };

        let roleName = this.editedItem.roleName;
        if (
          !roleName ||
          userRole.REPORTING_ADMIN_ROLE == roleName ||
          userRole.NO_ROLE == roleName
        ) {
          this.$log.debug(
            "current user",
            this.editedItem.id,
            "role",
            roleName,
            "requires no project assignments. Removing assignments"
          );
          this.projectVesselMappings.forEach((pvm) => (pvm.isAssigned = false));
        }

        this.projectVesselMappings.forEach((pvm) => {
          let pvIdx = this.editedItem.pvMappingIds.indexOf(pvm.id);
          if (pvm.isAssigned && pvIdx == -1) {
            assignments.toAdd.push({ uId: userId, pvmId: pvm.id });
          }

          if (!pvm.isAssigned && pvIdx !== -1) {
            assignments.toRemove.push({ uId: userId, pvmId: pvm.id });
          }
        });

        this.$log.debug("user <-> project-vessels assignments", assignments);
        var promises = [];

        assignments.toAdd.forEach((a) =>
          promises.push(this["m_user/createUserProjectVesselMapping"](a))
        );
        assignments.toRemove.forEach((a) =>
          promises.push(this["m_user/deleteUserProjectVesselMapping"](a))
        );

        return Promise.all(promises);
      },

      onRoleChange(selRoleId) {
        var roles = this.roles.filter((r) => r.id == selRoleId);
        this.$log.debug("role changed to ", roles[0]);
        this.$set(this.editedItem, "roleName", (roles[0] || {}).description);
      },
    },
  };
</script>

<style>
  #userssTable {
    margin-left: auto;
    margin-right: auto;
    width: auto;
    height: auto;
  }
  #userssTable header {
    font-weight: bold;
  }
  #userssCard {
    width: auto;
  }
</style>
